<template>
  <v-row>
    <v-col cols="12" class="d-flex align-center gap-8">
      <div class="img-box">
        <img
          src="/img/logo/logo-prompt-plus.svg"
          alt=""
          style="width: 100%; height: 100%; object-fit: contain"
        />
      </div>
      <span class="font-16 font-w-500">สถานะพร้อมพลัส : </span>
    </v-col>
    <v-col cols="6" class="font-16 d-flex align-center gap-5">
      <span>ลงทะเบียนพร้อมพลัส :</span>
      <div v-if="bpDetail.ispp === 'Yes'" class="d-flex align-center gap-4">
        <v-avatar size="16" color="#E4F3E1">
          <v-icon size="10" color="#1C9D06">mdi-check</v-icon>
        </v-avatar>
        <span class="font-grey">ใช่</span>
      </div>
      <div v-else class="d-flex align-center gap-4">
        <v-avatar size="16" color="#ECECEC">
          <v-icon size="10" color="#000000">mdi-close</v-icon>
        </v-avatar>
        <span class="font-grey">ไม่ใช่</span>
      </div>
    </v-col>
    <v-col cols="6" class="font-16 d-flex align-center gap-5">
      <span>สถานะการซื้อบนพร้อมพลัส :</span>
      <div class="d-flex align-center gap-6">
        <div
          v-if="bpDetail.so_retention_status === 'Retention'"
          class="badge--green"
        >
          <span>{{ bpDetail.so_retention_status }}</span>
        </div>
        <div
          v-else-if="bpDetail.so_retention_status === 'Just Lost'"
          class="badge--yellow"
        >
          <span>{{ bpDetail.so_retention_status }}</span>
        </div>
        <div
          v-else-if="bpDetail.so_retention_status === 'Lost'"
          class="badge--red"
        >
          <span>{{ bpDetail.so_retention_status }}</span>
        </div>
        <div v-else class="badge--grey">
          <span>{{ bpDetail.so_retention_status || 'None' }}</span>
        </div>

        <v-tooltip bottom color="#ffffff00">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" size="22">
              mdi-information-outline
            </v-icon>
          </template>
          <div class="status-tooltip">
            <span class="font-16 font-grey">สถานะการซื้อ : </span>
            <span
              v-if="bpDetail.so_retention_status === 'Retention'"
              class="font-16 font-w-500"
            >
              {{ bpDetail.so_retention_status_TH }}
            </span>
            <span
              v-else-if="bpDetail.so_retention_status === 'Just Lost'"
              class="font-16 font-w-500"
            >
              {{ bpDetail.so_retention_status_TH }}
            </span>
            <span
              v-else-if="bpDetail.so_retention_status === 'Lost'"
              class="font-16 font-w-500"
            >
              {{ bpDetail.so_retention_status_TH }}
            </span>
            <span v-else class="font-16 font-w-500">
              {{ bpDetail.so_retention_status_TH }}
            </span>
          </div>
        </v-tooltip>
      </div>
    </v-col>
    <v-col cols="6" class="font-16 d-flex align-center gap-5">
      <span>ลงทะเบียน Line OA พร้อมพลัส :</span>
      <div v-if="bpDetail.islineoa === 'Yes'" class="d-flex align-center gap-4">
        <v-avatar size="16" color="#E4F3E1">
          <v-icon size="10" color="#1C9D06">mdi-check</v-icon>
        </v-avatar>
        <span class="font-grey">ใช่</span>
      </div>
      <div v-else class="d-flex align-center gap-4">
        <v-avatar size="16" color="#ECECEC">
          <v-icon size="10" color="#000000">mdi-close</v-icon>
        </v-avatar>
        <span class="font-grey">ไม่ใช่</span>
      </div>
    </v-col>
    <v-col cols="6" class="font-16">
      <div class="d-flex align-center gap-5">
        <div class="d-flex align-center gap-4">
          <span>พฤติกรรมลูกค้าบนพร้อมพลัส :</span>
          <section :class="soSegmentColor(bpDetail.so_segment)">
            <span>{{ bpDetail.so_segment || 'None' }}</span>
          </section>
        </div>
      </div>
      <div class="font-13">
        <span v-if="bpDetail.so_segment === 'Champion'">
          (ความถี่ในการซื้อ = มาก, ยอดซื้อ = มาก)
        </span>
        <span v-else-if="bpDetail.so_segment === 'Loyal'">
          (ความถี่ในการซื้อ = มาก, ยอดซื้อ = ปานกลาง)
        </span>
        <span v-else-if="bpDetail.so_segment === 'Potential'">
          (ความถี่ในการซื้อ = ปานกลาง, ยอดซื้อ = มาก)
        </span>
        <span v-else-if="bpDetail.so_segment === 'Build Monetary'">
          (ความถี่ในการซื้อ = มาก, ยอดซื้อ = น้อย)
        </span>
        <span v-else-if="bpDetail.so_segment === 'At Risk'">
          (ความถี่ในการซื้อ = ปานกลาง, ยอดซื้อ = น้อย)
        </span>
        <span v-else-if="bpDetail.so_segment === 'Average'">
          (ความถี่ในการซื้อ = ปานกลาง, ยอดซื้อ = ปานกลาง)
        </span>
        <span v-else-if="bpDetail.so_segment === 'Lost'">
          (ความถี่ในการซื้อ = น้อย, ยอดซื้อ = น้อย)
        </span>
        <span v-else-if="bpDetail.so_segment === 'About to Sleep'">
          (ความถี่ในการซื้อ = น้อย, ยอดซื้อ = ปานกลาง)
        </span>
        <span v-else-if="bpDetail.so_segment === 'Build Frequency'">
          (ความถี่ในการซื้อ = น้อย, ยอดซื้อ = มาก)
        </span>
        <span v-else>(ไม่มีข้อมูล เนื่องจากไม่มีการซื้อขายบนพร้อมพลัส)</span>
      </div>
    </v-col>
    <v-col cols="6" class="font-16 d-flex align-center gap-5">
      <span>สมาชิกช้างแฟมมิลี่ :</span>
      <div v-if="bpDetail.ismember === 'Yes'" class="d-flex align-center gap-4">
        <v-avatar size="16" color="#E4F3E1">
          <v-icon size="10" color="#1C9D06">mdi-check</v-icon>
        </v-avatar>
        <span class="font-grey">ใช่</span>
      </div>
      <div v-else class="d-flex align-center gap-4">
        <v-avatar size="16" color="#ECECEC">
          <v-icon size="10" color="#000000">mdi-close</v-icon>
        </v-avatar>
        <span class="font-grey">ไม่ใช่</span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    bpDetail: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    soSegmentColor(value) {
      switch (value) {
        case 'Champion':
          return 'badge--green'
        case 'Loyal':
          return 'badge--green'
        case 'Potential':
          return 'badge--green'
        case 'Build Monetary':
          return 'badge--orange'
        case 'At Risk':
          return 'badge--orange'
        case 'Average':
          return 'badge--orange'
        case 'Lost':
          return 'badge--red'
        case 'About to Sleep':
          return 'badge--red'
        case 'Build Frequency':
          return 'badge--red'
        default:
          return 'badge--grey'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.img-box {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  padding: 4px;
  background: #faf3f4;
}

.status-tooltip {
  border-radius: 38px;
  border: 1px solid #ececec;
  background: #fff;
  color: #000;
  padding: 8px 16px;
}

.badge {
  border-radius: 8px;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 500;

  &--green {
    @extend .badge;
    background: #60ad53;
    color: #fff;
  }
  &--yellow {
    @extend .badge;
    background: #f2cf65;
    color: #000;
  }
  &--red {
    @extend .badge;
    background: #b65862;
    color: #fff;
  }
  &--grey {
    @extend .badge;
    background: #a2a2a2;
    color: #fff;
  }
  &--orange {
    @extend .badge;
    background: #eda06e;
    color: #fff;
  }
}
</style>
